import React from "react";
import { addS3Url } from "../utils/modules";

const Menu = ({ onClick }) => {
  return (
    <div
      className="d-flex flex-row align-items-center justify-content-start"
      style={{
        height: "3.7svh",
        maxHeight: "80px",
        width: "85%",
        alignSelf: "center",
      }}
    >
      <img
        src={addS3Url("/courses/menu.svg")}
        alt=""
        width={25}
        height={20}
        className=""
        onClick={() => onClick()}
      />
    </div>
  );
};

export default Menu;
